import http from '../http';
import { COLLECTION_AREA_API } from '@/config/env';


export const createAreaPrice = (areaPrice: any) => {
  return http.post(`/collection-area`, areaPrice, { returnFullResponse: true });
};

export const getAreaPrices = (type:String) => {
  return http.get(`/collection-area`, { params: { type } });
};

export const deleteAreaPriceById = (id: number) => {
  return http.delete(`/collection-area/${id}`);
};

export const updateAreaPrice = (id: number, areaPrice: any) => {
  return http.put(`/collection-area/${id}`, areaPrice);
};

export const isExistsByAreaName = (areaName: string,currentAreaId: string,type: string) => {
  return http.get(`/collection-area/exists-by-name/${currentAreaId}`, { params: { areaName,type } });
};

export const isExistsByPostCode = (posCode: string,type:string) => {
  return http.get(`/collection-area/exists-by-pos-code`, { params: { posCode,type } });
};

export const findByTypeAndPosCode = (type: string, posCode: string) => {
  return http.get(`${COLLECTION_AREA_API}/type/${type}/pos-code/${posCode}`, {
    returnFullResponse: true
  });
};
